import { triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function JangguPlayer(props: InstrumentPlayerProps) {
  return (
    <div className="instrument-ui janggu-ui" data-testid="instrument-player-janggu">
      <div className="janggu-body" aria-label="Hourglass janggu body" data-control-target="janggu-heads">
        <button type="button" className="janggu-head low-head" aria-label="Play janggu gung bukpyeon low head" data-testid="janggu-gung-button" onClick={() => triggerMomentary(props, "C4", "gung", 0.86, 180)}>
          Gung
          <small>bukpyeon / gungpyeon alias</small>
        </button>
        <div className="janggu-waist" aria-hidden="true" />
        <button type="button" className="janggu-head high-head" aria-label="Play janggu chaepyeon high head" data-testid="janggu-chaepyeon-button" onClick={() => triggerMomentary(props, "G4", "chaepyeon", 0.78, 180)}>
          Chae
          <small>strokeId and label split</small>
        </button>
      </div>
      <div className="instrument-control-strip">
        <select aria-label="Select jangdan preset" data-control-target="janggu-jangdan">
          <option>Semachi labels</option>
          <option>Gutgeori labels</option>
          <option>Jajinmori labels</option>
          <option>Context-specific labels</option>
        </select>
        <button type="button" aria-label="Play janggu both open heads" data-testid="janggu-both-open-button" onClick={() => props.onControl("janggu_both_open")}>
          Both open +4ms
        </button>
        <details className="scholarly-detail">
          <summary>Scholarly detail</summary>
          <p>Internal material metadata is kept out of casual UI and only appears here.</p>
        </details>
      </div>
    </div>
  );
}
